<div [class.rounded]="rounded()" class="avatar-placeholder d-flex flex-row justify-content-center align-items-center">
  {{ initials() || ':(' }}
</div>
